export default __webpack_public_path__ + "static/media/engineered-wood.005ee747.svg";